import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { loginSliceValue } from "../redux/reducers/loginSlice";

import { Content } from "../components";
import SuremedCharts from "../pageComponents/Home/Suremed";
import AllCharts from "../pageComponents/Home/All";
import RTMDashboard from "../pageComponents/Dashboard/RTMDashboard";
import { useNavigate } from "react-router-dom";

const HomeScreen = () => {
  const { userDetails } = useSelector(loginSliceValue);
  const userRole = userDetails?.data?.user?.role;
  const navigate = useNavigate();

  useEffect(() => {
    if (userRole === "rtmProvider") {
      navigate("/Patient");
    }
  }, [userRole, navigate]);

  const isRTMRole =
    userRole === "clinician" ||
    userRole === "rtmProvider" ||
    userRole === "rtmAdmin" ||
    userRole === "rtmManager";

  return (
    <Content
      currentMenu="dashboard"
      headerTitle="Dashboard"
      addBtn={false}
      searchBox={false}
    >
      {isRTMRole ? <RTMDashboard /> : <AllCharts />}
    </Content>
  );
};

export default HomeScreen;
